import { render, staticRenderFns } from "./Recursive.vue?vue&type=template&id=10b84f67&scoped=true&"
import script from "./Recursive.vue?vue&type=script&lang=js&"
export * from "./Recursive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b84f67",
  null
  
)

export default component.exports